module.exports = __webpack_public_path__ + "static/hr-cloud-bw-69871699e25eba0ee18b626f28e02bfb.jpg";